import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faHourglassStart
} from "@fortawesome/free-solid-svg-icons";

function PlayerPoints(props) {
  const { fixtures = [], points } = props;

  if (!fixtures || fixtures.length === 0) {
    return null;
  }

  const lpFixturesToBePlayed = (fixtures.filter(f => !f.Started)).length;
  const lpInGame = fixtures.some(f => f.Started && !f.Finished) ?? false;

  return (
    <span>
      {
          lpFixturesToBePlayed > 0 && (
              <FontAwesomeIcon icon={faCalendarDays} />
          )
      }
      {
          lpInGame && (
              <span>
                  <FontAwesomeIcon icon={faHourglassStart} className="in-game-icon" />
                  {points}
              </span>
          )
      }
      {
          lpFixturesToBePlayed === 0 && !lpInGame && (
              <span>{points}</span>
          )
      }
    </span>
  );
}

export default PlayerPoints;
